<template>
  <st-dialog
    :title="modalTitle"
    v-model="dialogVisible"
    width="800"
    :drag-and-resizable="true"
    :show-fullscreen-button="true"
  >
    <!-- Is closed goes here -->
    <v-row v-if="isContentForClosed">
      <v-col
        lg="12"
        md="12"
      >
        <!-- <st-date-picker-v2
        v-model="working_date"
        :max="maxValidDate"
        :min="minValidDate"
        :rules="workingDateRules"
        :value="working_date"
        clearable
        label="Working Day"
        prepend-icon="mdi-calendar"
        /> -->
        <div class="d-flex">
          <st-date-picker-v2
            v-model="working_date"
            :max="maxValidDate"
            :min="minValidDate"
            :rules="workingDateRules"
            :value="working_date"
            label="Working Day"
            prepend-icon="mdi-calendar"
            :readonly="true"
          />
          <v-btn
            @click="getMyClosedWorkingDay"
            v-if="!isSuccessGetClosedWorkingDay"
            title="refresh working day"
            icon
            class="mt-2"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>
        <p
          class="ml-4 mt-0 mb-0"
          style="position: relative;top:-20px;"
        >
          Last Closing Day: {{ lastClosingDay }}
        </p>
        <p
          class="ml-4 mt-0 mb-0"
          style="position: relative;top:-20px;"
        >
          {{ message }}
        </p>
      </v-col>
    </v-row>
    <!-- <v-row v-else>
      <v-col lg="12" md="12">
        <st-data-table
          :headers="ClosedDayActionsHeaders"
          :items="closedDayActions"
          :search="searchClosedDayActions"
          :serverSide="false"
        >
          <template v-slot:[`item.status`]="{ item }">
            <v-checkbox
              v-model="selectedClosedDayActions"
              :value="item.no"
            ></v-checkbox>
          </template>
        </st-data-table>
      </v-col>
    </v-row> -->
    <div v-else>
      <v-row style="margin-top: 10px">
        <v-col cols="8">
          <div>
            <strong>{{ $t('sharedCommon.closeDay') }}</strong>
          </div>
          <div>
            {{ $t('sharedCommon.currentWorkingDate') }}: <strong>{{ currentWorkingDateStr }}</strong>
          </div>
        </v-col>

        <v-col
          cols="4"
          style="text-align: right"
        >
          <v-btn
            :disabled="workingDayClosed"
            :loading="closeDayLoading"
            class="ma-1"
            color="primary"
            @click="run()"
          >
            {{ $t('sharedCommon.run') }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row style="margin-top: 10px; border-top: 1px #ccc solid;">
        <v-col
          cols="4"
          style="font-size: 20px; color: blue; font-weight: bold; margin-top: 30px"
        >
          {{ $t('sharedCommon.remaining') }}: {{ totalTasksRemaining }}
        </v-col>
        <v-col
          cols="4"
          style="font-size: 20px; color: green; font-weight: bold; margin-top: 30px"
        >
          {{ $t('sharedCommon.completed') }}: {{ totalTasksCompleted }}
        </v-col>
        <v-col
          cols="4"
          style="text-align: right"
        >
          <v-progress-circular
            :rotate="360"
            :size="70"
            :width="15"
            :value="progress"
            color="teal"
          >
            {{ progress }}%
          </v-progress-circular>
        </v-col>
      </v-row>

      <v-row style="margin-top: -10px">
        <v-col>
          <v-data-table
            :headers="ClosedDayActionsHeaders"
            :items="closedDayActions"
            :items-per-page="20"
            class="elevation-1"
            :hide-default-footer="true"
            :hide-default-header="true"
          >
            <template #[`item.status`]="{ item }">
              <div>
                <!-- <v-checkbox style="margin-top: 0px; margin-bottom: -20px;"
                    v-model="item.status"
                  ></v-checkbox> -->
                <v-scroll-x-transition>
                  <v-icon
                    v-if="item.status"
                    color="success"
                  >
                    mdi-check
                  </v-icon>
                </v-scroll-x-transition>
                <v-scroll-x-transition>
                  <v-icon
                    v-if="!item.status && item.run"
                    color="error"
                  >
                    mdi-close
                  </v-icon>
                </v-scroll-x-transition>
              </div>
            </template>

            <template #[`item.remarks`]="{ item }">
              <div :style="item.status ? 'color: green' : 'color: red'">
                {{ item.remarks }}
              </div>
            </template>
            <template #[`item.no`]="{ item, index }">
              {{ index + 1 }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>

    <template slot="action">
      <v-spacer v-if="isClosed" />
      <v-btn
        v-if="isClosed"
        outlined
        text
        @click="closeDialog"
      >
        {{ $t('sharedCommon.cancel') }}
      </v-btn>
      <v-btn
        v-if="isClosed"
        :loading="loading"
        :color="(isOpen)? 'error' : 'success' "
        @click="switchStatus"
      >
        {{ translatedSwitchString }}
      </v-btn>
    </template>
  </st-dialog>
</template>

<script lang="ts">
import {Mixins, Component, Prop, Watch} from "vue-property-decorator";
import PageHeader from "@/pages/master-data/coa/components/header.vue";
import IndexMixin from "@/mixins";
import WDMixin from "../mixins";
import dayjs from "dayjs";
import {ApiRuntimeSize} from "@/services/Api";
import signalGo from "@/services/SignalGo";

type Rules = (val: any) => string | boolean;

@Component({
  mixins: [IndexMixin, WDMixin],
  components: {PageHeader}
})
export default class SwitchWorkingDayStatus extends Mixins(IndexMixin, WDMixin) {
  @Prop({default: false, required: true})
  declare public dialogVisible: boolean;
  @Prop({type: String, default: "Title Here", required: true})
  public title: string;
  public loading: boolean = false;
  public working_date: Date | null = null;
  // public working_date: Date | undefined = undefined;
  public last_working_date: Date = new Date();
  public workingDateRules: Rules[] = [(v) => !!v || this.$t("sharedCommon.itemIsRequired", { item: this.$t("sharedCommon.field").toString() }).toString()];
  public message:string = "";
  public searchClosedDayActions:string = "";
  public progress: number=0;
  public currentWorkingDateStr = dayjs(this.$store.state.app.closed_day.working_date).format("DD MMM YYYY");
  public closeDayLoading: boolean = false;

  public selectedClosedDayActions:Object[] = []; // see ClosedDayActions
  public workingDayClosed = false;

  get isContentForClosed() {
    if(this.recentlyClosed && this.isClosed) {
      return false;
    } else {
      return this.isClosed;
    }
  }
  
  public ClosedDayActionsHeaders:Object[] = [
    {
      text: "No",
      align: "start",
      filterable: false,
      value: "no",
      width: "25px"
    },
    { text: "Item", value: "item" },
    { text: "Status", value: "status" },
    { text: "Remark", value: "remarks" },
  ];

  get translatedSwitchString() {
    return this.$t("localCommon." + this.switchString.toLowerCase().replace(" ","") + "Day").toString();
  }

  get closedDayActions() : any[] {
    const defaultActions = [
      {
        no: 1,
        item: this.$t("sharedCommon.checkPendingTables").toString(),
        status: false,
        remarks: "",
      },
      {
        no: 2,
        item: this.$t("sharedCommon.createEntriesRevenue").toString(),
        status: false,
        remarks: "",
      },
      {
        no: 3,
        item: this.$t("sharedCommon.createEntriesInvoice").toString(),
        status: false,
        remarks: "",
      },
      {
        no: 4,
        item: this.$t("sharedCommon.createEntriesPayment").toString(),
        status: false,
        remarks: "",
      },
      {
        no: 5,
        item: this.$t("sharedCommon.closeCurrentWorkingDate").toString(),
        status: false,
        remarks: "",
      },
    ];
    if (this.hasIntercompanyMappingAsSource) {
      defaultActions.splice(1, 0,
        {
          no: 0,
          item: this.$t("intercompanyMapping.checkTargetOutletStatus").toString(),
          status: false,
          remarks: "",
        }
      );
      defaultActions.splice(5,0,
        {
          no: 0,
          item: this.$t("intercompanyMapping.createIntercompanyMappingEntries").toString(),
          status: false,
          remarks: "",
        }
      ); 
    }
    if (this.hasIntercompanyMappingAsTarget) {
      defaultActions.unshift(
        {
          no: 0,
          item: this.$t("intercompanyMapping.checkSourceOutletStatus").toString(),
          status: false,
          remarks: "",
        }
      );
    }
    return defaultActions;
  }
  // remarks = [
  //   "All tables should be closed / paid",
  //   "Table FO 602 - Reservation Revenue Line",
  //   "Table FO 651-652 - Invoice Header and Line",
  //   "Table FO 611 - Cash Desk Movement",
  //   "Also Update Closing Invoice Number",
  // ]
  public totalTasks: number = this.closedDayActions.length;
  public totalTasksRemaining: number = this.totalTasks;
  public totalTasksCompleted: number = 0;
  get modalTitle() {
    return this.switchString + this.title + " for " + this.$store.state.app.outlet.name;
  }

  public maxValidDate:string = dayjs(new Date()).format();
  public minValidDate:string = dayjs(new Date()).format();

  private setMinValidDate(working_date:Date, i:number = 0) {
    this.minValidDate = dayjs(working_date).add(i, "days").format();
  }

  private setMaxValidDate(working_date:Date, i:number = 0) {
    this.maxValidDate = dayjs(working_date).add(i, "days").format();
  }

  @Watch("dialogVisible")
  toggle(newVal) {
    if (newVal) {
      this.setMinValidDate(new Date());
      this.setMaxValidDate(new Date());
      if(this.isClosed) {
        this.getMyClosedWorkingDay();
      }
    } else {
      this.$emit("close");
      if(this.recentlyClosed) {
        this.recentlyClosed = false;
      }
      if(this.workingDayClosed) {
        this.$store.dispatch("app/getMyWorkingDay", {hotelId: this.hotelId, outletId: this.outletId});
        this.workingDayClosed = false;
      }
    }
  }

  public closeDialog() {
    this.$emit("close");
  }

  private deleteUnusedPayload() {
    const payload = {...this.activeWD};
    delete payload.created;
    delete payload.created_by;
    delete payload.last_modified;
    delete payload.last_modified_by;
    return payload;
  }

  public openPayload() {
    const payload:any = {...this.deleteUnusedPayload()};
    payload.outlet_id = this.outletId;
    payload.hotel_id = this.hotelId;
    payload.open_by = this.$store.state.app.user.id;
    payload.open_date = dayjs();
    payload.working_date = dayjs(this.working_date || undefined);

    payload.closed_by = null;
    payload.closed_date = null;
    return payload;
  }

  public closingPayload() {
    const payload:any = {...this.deleteUnusedPayload()};
    payload.closed_by = this.$store.state.app.user.id;
    payload.closed_date = dayjs();
    return payload;
  }

  public async doCloseWD() {
    this.$archConfirm({
      confirmButtonColor: "error",
      cancelButtonColor: "",
      message: "Are you sure?",
      title: "Close Working Day",
    })
      .then(async () => {
        try {
          await this.$http.post(this.posUrl("closed-day"), this.closingPayload());
          this.succNotify("Working day closed!");

          try {
            window.location.href = window.location.href;
            location.reload();
          } catch (e) {
            this.errNotify("Something went wrong, please RELOAD the page!");
          }

        } catch (e) {
          this.errNotify("Cannot close working day, something went wrong!");
        }
      })
      .catch(() => {
        //
      });
  }

  public async doOpenWD() {
    this.$archConfirm({
      confirmButtonColor: "error",
      cancelButtonColor: "",
      message: `Start working day for ${dayjs(this.working_date || undefined).format("D MMMM YYYY")}?`,
      title: "Start Working Day",
    })
      .then(async () => {
        try {
          await this.$http.post(`/hotel/{hotelId}/pos/${this.outletId}/open-day/v1?`, this.openPayload());
          this.succNotify("Working day opened!");

          try {
            window.location.href = window.location.href;
            location.reload();
          } catch (e) {
            this.errNotify("Something went wrong, please RELOAD the page!");
          }

        } catch (e) {
          this.errNotify("Cannot open working day, something went wrong!");
        }
      })
      .catch(() => {
        //
      });
  }

  public switchStatus() {
    if (this.isOpen) {
      this.doCloseWD();
    } else {
      this.doOpenWD();
    }
  }

  public wdUrl(token) {
    return `/my/last-closed-day/v1?userId=${this.getUid(token)}&hotelId=${this.hotelId}&outletId=${this.outletId}&date=${dayjs().format("YYYY-MM-DD-HH:mm:ss")}`;
  }

  async getOutlets() {
    return this.$http
      .get(`/my/outlets/${this.$store.state.app.user.id}/v1?hotelId=${this.hotelId}`);
  }

  get state() {
    return this.$store.state;
  }

  isSuccessGetClosedWorkingDay: boolean = true;

  async getMyClosedWorkingDay() {
    let msg = "";
    this.loading = true;
    let updatedOutlets;
    try {
      updatedOutlets = await this.getOutlets();
    } catch (error: any) {
      this.isSuccessGetClosedWorkingDay = false;
      this.loading = false;
      this.message = `Error: ${error?.message || "failed to get latest working day data"}`;
      return;
    }
    this.isSuccessGetClosedWorkingDay = true;
    this.state.app.outlets = (updatedOutlets?.data?.Data || []);
    const currOutlet = { ...(updatedOutlets?.data?.Data || []).find(el => el.id === this.$store.state.app.outlet.id) };
    this.state.app.outlet = currOutlet;
    this.working_date = currOutlet.fo_working_date;
    if (currOutlet.working_date) {
      this.last_working_date = currOutlet.working_date;
      const overLap = dayjs(this.working_date || undefined).isSame(this.last_working_date, "day") || dayjs(this.working_date || undefined).isBefore(this.last_working_date, "day");
      if (overLap) {
        if (this.working_date) {
          this.setMinValidDate(this.working_date, 0);
          this.setMaxValidDate(this.working_date, 0);
        }
        msg = `Closed at ${this.strDate(currOutlet.closed_date, 0)}`;
      } else {
        msg = `Closed at ${this.strDate(currOutlet.closed_date, 1)} ago`;
      }
    } else {
      msg = `This is the first day ${currOutlet.name} is open.`;
    }
    this.loading = false;
    this.message = msg;
  }
  async run(){
    this.totalTasksRemaining = this.totalTasks;
    this.totalTasksCompleted = 0;

    this.closeDayLoading = true;
    const that = this;
    const url = `/longrequest/hotel/{hotelId}/pos/${this.outletId}/close-day/v1`;
    this.$http.post(url, {
      "hotel_id": that.hotelId
    }, 3600, ApiRuntimeSize.Medium)
    .catch(() => {
      this.closeDayLoading = false;
    });
  }

  mounted() {
    this.openCloseDay();
  }

  destroyed() {
    signalGo.Unsubscribe(`pos_close_day_progress_event_${this.outletId}`);
  }
  openCloseDay(){
    signalGo.Connect({});
    const that = this;
    signalGo.Subscribe(`pos_close_day_progress_event_${this.outletId}`, (e) => {
      that.ListenToOrder(e);
    });

    // this.dialog = true
  }
  recentlyClosed = false;
  async ListenToOrder(e) {
    const that = this;
    // Belt-and-suspenders: ignore events for other outlets (harmless when the
    // field is absent, e.g. pre-Phase-1 backend that has not yet enriched the payload).
    if (e.content.outlet_id != null && Number(e.content.outlet_id) !== Number(this.outletId)) {
      return;
    }
    const i = e.content.step;
    const message = e.content.message || e.content.error;
    const status = e.content.success;
    // Prefer the backend's authoritative step count; fall back to the local row
    // count when total_steps is absent (transitional/old backend).
    const totalSteps = e.content.total_steps ?? this.closedDayActions.length;
    const completed = e.content.step === totalSteps && status;

    // Guard against out-of-range steps (e.g. a step index that exceeds the local
    // checklist rows) so a stray event cannot throw and freeze the checklist.
    const action = that.closedDayActions[i - 1];
    if (!action) {
      return;
    }
    action.remarks = message;
    action.status = status;
    action.run = true;

    if(!status){
      this.closeDayLoading = false;
    } else {
      this.progress = Math.ceil((i / this.totalTasks) * 100);
      this.totalTasksCompleted = this.totalTasksCompleted + 1;
      this.totalTasksRemaining = this.totalTasksRemaining - 1;
    }
    if (completed){
      this.recentlyClosed = true;
      this.closeDayLoading = false;
      this.$archNotify({showClose: true, message: "Close Day completed", color: "success"});
      this.workingDayClosed = true;
      await this.$store.dispatch("app/getMyWorkingDay", {hotelId: this.hotelId, outletId: this.outletId});
      await this.getMyClosedWorkingDay();
      this.$emit("dayClosed");
      if(!this.$route.path.includes("outlet-status") && !this.$route.path.includes("working-day")) {
        setTimeout(() => {
          this.$router.push(`/outlet-status?hotelId=${this.hotelId}&outletId=${this.outletId}`);
        }, 200);
      }
    }
  }

  get lastClosingDay() {
    if(!this.$store.state.app.last_closed_day.working_date) {
      return "-";
    }
    return dayjs(this.$store.state.app.last_closed_day.working_date).format("D MMMM YYYY");
  }
  get posParameter() {
    return this.$store?.state?.app?.parameter;
  }
  get hasIntercompanyMappingAsSource() {
    return this.posParameter?.is_intercompany_mapping_as_source_exist;
  }

  get hasIntercompanyMappingAsTarget() {
    return this.posParameter?.is_intercompany_mapping_as_target_exist;
  }
}
</script>

<style scoped>

</style>
